import { CREATE_USER_ADDRESS_REQUEST, CREATE_USER_ADDRESS_SUCCESS, CREATE_USER_ADDRESS_FAILURE } from '../../constants/user_address.constants';

export const createUserAddressRequest = (country, city, street, zip_code, state, user_id) => ({
    type: CREATE_USER_ADDRESS_REQUEST, country, city, street, zip_code, state, user_id,
});
export const createUserAddressRequestSuccess = payload => ({ type: CREATE_USER_ADDRESS_SUCCESS, payload });
export const createUserAddressRequestFailure = error => ({ type: CREATE_USER_ADDRESS_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_addresses_actions/create_users_address.actions.js